import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  reduxForm,
  isValid,
  getFormValues,
  getFormInitialValues,
  Field,
  change,
} from 'redux-form';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as actPaymentMethod from 'actions/setting/paymentMethod';
import { find, mapKeys, forEach, filter, includes } from 'lodash';
import * as actNotif from 'actions/notifications';
import { LIST_EWALLET_REQUIRED_KTP_NAME } from 'utils/paymentMethodConstants';
import UploadImage from 'components/Fields/ReduxForm/UploadImage';
import gravatarDefault from 'assets/images/account-profile-default.jpg';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import SettingLetter from 'components/Fields/ReduxForm/SettingLetter';
import DropdownBank from 'components/Fields/ReduxForm/DropdownBank';
import styles from './styles.css';
import ModalAssignOutletsOnRegistration from './ModalAssignOutletsOnRegistration';

const FIELD_IS_REQUIRED = 'This field is required';

const validate = values => {
  const errors = {};
  if (!values.business_name || values.business_name.trim() === '') {
    errors.business_name = FIELD_IS_REQUIRED;
  } else if (values.business_name.length > 21) {
    errors.business_name = 'Only 21 characters allowed';
  }
  if (!values.ktp_number || values.ktp_number.trim() === '') {
    errors.ktp_number = FIELD_IS_REQUIRED;
  } else if (values.ktp_number.trim().length !== 16) {
    errors.ktp_number = 'This field must contains 16 characters';
  }
  if (values.npwp_number && values.npwp_number.trim().length !== 15) {
    errors.npwp_number = 'This field must contains 15 characters';
  }
  if (!values.bank_account_number || values.bank_account_number.trim() === '') {
    errors.bank_account_number = FIELD_IS_REQUIRED;
  }
  if (!values.holder_name || values.holder_name.trim() === '') {
    errors.holder_name = FIELD_IS_REQUIRED;
  } else if (!/^[A-Za-z ]+$/.test(values.holder_name)) {
    errors.holder_name = 'This field must contains letters only';
  }
  if (!values.bank_name) {
    errors.bank_type = FIELD_IS_REQUIRED;
  }
  if (!values.swift_code) {
    errors.bank_type = FIELD_IS_REQUIRED;
  }
  return errors;
};

const PrefixForm = props => {
  const { input } = props;
  return (
    <div>
      <input type="text" className="form-control" {...input} disabled />
    </div>
  );
};

class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploading: false,
    };
  }

  onChangeAccordion = key => {
    const { isValidPaymentRegistration } = this.props;
    if (isValidPaymentRegistration) {
      this.props.dispatch(actPaymentMethod.setActiveAccordionKey(key));
    }
  };

  isSubmitButtonDisabled = () => {
    const { isValidPaymentRegistration } = this.props;
    return !isValidPaymentRegistration;
  };

  onClickSubmitButton = () => {
    const { outlets, businessBankAccountList } = this.props;
    const validOutlet = this.isValidatOutlet(outlets, businessBankAccountList);
    if (validOutlet) {
      this._updateKtpNpwpNumber();
      this._savePaymentMethod();
    } else {
      this.props.dispatch(
        actNotif.error('Please Assign Outlet to Bank Account')
      );
    }
  };

  _savePaymentMethod = () => {
    const {
      userData: { business },
      outlets,
      selectedPaymentMethodList,
    } = this.props;
    const { formValuePaymentRegistration } = this.props;
    this.props.dispatch(
      actPaymentMethod.onClickSubmitEWalletPayment(
        selectedPaymentMethodList,
        formValuePaymentRegistration,
        outlets,
        business
      )
    );
  };

  isFieldValid = value => {
    return value ? undefined : FIELD_IS_REQUIRED;
  };

  _updateKtpNpwpNumber = () => {
    const {
      initPaymentRegistration,
      formValuePaymentRegistration,
    } = this.props;
    if (
      !initPaymentRegistration.ktp_number ||
      !initPaymentRegistration.npwp_number ||
      !initPaymentRegistration.ktp_name
    ) {
      this.props.dispatch(
        actPaymentMethod.updateKtpNpwp(
          formValuePaymentRegistration.ktp_number,
          formValuePaymentRegistration.npwp_number,
          formValuePaymentRegistration.ktp_name
        )
      );
    }
  };

  _generateBankList = bankList => {
    return bankList.map(bank => {
      return {
        name: bank.bank_name,
        swift_code: bank.swift_code,
      };
    });
  };

  _onChangeBankName = (e, generatedBankList) => {
    const bank = find(generatedBankList, o => {
      return o.name === e.target.value;
    });
    this.props.dispatch(
      change('paymentRegistration', 'bank_name', e.target.value)
    );
    this.props.dispatch(
      change('paymentRegistration', 'swift_code', bank.swift_code)
    );
  };

  _onClickAddBankAccount = () => {
    const {
      formValuePaymentRegistration: {
        bank_name: bankName,
        bank_account_number: bankAccountNumber,
        holder_name: holderName,
      },
      bankList,
      businessBankAccountList,
    } = this.props;

    if (businessBankAccountList.length > 0) {
      this.props.dispatch(
        actPaymentMethod.onClickAddBankAccountOpenBankAccountModal()
      );
      return;
    }

    if (!bankName || !bankAccountNumber || !holderName) {
      return;
    }

    const bankId = find(bankList, o => {
      return o.bank_name === bankName;
    }).id;
    const request = {
      account_holder_name: holderName,
      account_holder_number: bankAccountNumber,
      bank_id: bankId,
    };
    this.props.dispatch(
      actPaymentMethod.onClickAddBankAccount(request, businessBankAccountList)
    );
  };

  _onClickAssignBankAccount = bankAccountValue => {
    this.props.dispatch(
      actPaymentMethod.setSelectedOutletsModal(
        this.initSelectedOutlet(bankAccountValue.outlets)
      )
    );
    this.props.dispatch(
      actPaymentMethod.onRegisterPaymentMethodAssignOutlet(bankAccountValue)
    );
    this.props.dispatch(
      actPaymentMethod.showModalAssignOutletsOnRegistration()
    );
  };

  isValidatOutlet = (outlets, businessBankAccountList) => {
    const bankOutletIds = [];
    let status = true;
    const outletIds = outlets.map(outlet => {
      return outlet.id;
    });

    forEach(businessBankAccountList, bankAccount => {
      bankAccount.outlets.map(id => {
        bankOutletIds.push(id);
      });
    });

    outletIds.forEach(function(outletId) {
      if (!bankOutletIds.includes(outletId)) {
        status = false;
      }
    });
    return status;
  };

  isKtpNameMandatory = () => {
    const { selectedPaymentMethodList } = this.props;
    const mandatory = filter(selectedPaymentMethodList, e =>
      includes(LIST_EWALLET_REQUIRED_KTP_NAME, e.code)
    );
    return mandatory.length > 0;
  };

  initSelectedOutlet = bankOutlets => {
    return bankOutlets.map(outletId => {
      const outletObj = find(this.props.outlets, ['id', outletId]);
      if (outletObj !== undefined) {
        const { id, name } = outletObj;
        return { id, name };
      }
    });
  };

  countBankAccountActiveOutlet = bankAccountOutlets => {
    const { outlets } = this.props;
    let totalBankAccountActiveOutlet = 0;
    const outletIds = outlets.map(outlet => {
      return outlet.id;
    });

    bankAccountOutlets.forEach(function(outletId) {
      if (outletIds.includes(outletId)) totalBankAccountActiveOutlet++;
    });
    return totalBankAccountActiveOutlet;
  };

  render() {
    const {
      showModalAssignOutletsOnRegistration,
      outlets,
      bankList,
      businessBankAccountList,
    } = this.props;
    const hashedBank = mapKeys(bankList, 'id');
    const generatedBankList = this._generateBankList(bankList);
    const {
      ktp_number: ktpNumber,
      npwp_number: npwpNumber,
      ktp_name: ktpName,
    } = this.props.initPaymentRegistration;
    const isKtpNumberEmpty = !ktpNumber;
    const isNpwpNumberEmpty = !npwpNumber;
    const isKtpNameEmpty = !ktpName;

    return (
      <div
        id="payment-method"
        className={styles['registration-payment-methods']}
      >
        <div className={`${styles['form-outer-wrapper']} row`}>
          {showModalAssignOutletsOnRegistration && (
            <ModalAssignOutletsOnRegistration onSubmit={this._onModalSubmit} />
          )}
          <div className={`col-md-12 ${styles['mt-25px']}`}>
            <div className={styles['form-wrapper']}>
              <h3 className="text-center">{`E-WALLET Registration`}</h3>
              <div className={styles['form-inner-wrapper']}>
                <h4>{`Account Information`}</h4>
                <hr />
                <div className={`row ${styles['mb-25px']}`}>
                  <div className="col-md-4">
                    <Field
                      name="gravatar"
                      component={UploadImage}
                      defaultImage={gravatarDefault}
                      imageContainerClassName={styles['upload-image-content']}
                      className={styles['upload-image']}
                      beforeUpload={() => {
                        this.setState({ uploading: true });
                      }}
                      afterUpload={() => {
                        this.setState({ uploading: false });
                      }}
                    />
                  </div>
                  <div className="col-md-8">
                    <div className={`row ${styles['mb-25px']}`}>
                      <div className="col-md-12">
                        {`Business Name`}
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip">
                              {`This will be your business name in OVO. It will not affect your current business name in Moka.`}
                            </Tooltip>
                          }
                        >
                          <img
                            style={{
                              position: 'relative',
                              top: '-2px',
                              marginLeft: 10,
                              cursor: 'pointer',
                            }}
                            src={require('assets/images/info-tooltip.png')}
                          />
                        </OverlayTrigger>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <Field
                            component={PrefixForm}
                            name="prefix"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-md-9">
                        <div className="form-group">
                          <Field
                            component={SettingField}
                            type="text"
                            name="business_name"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        {`Total : `}
                        <span
                          className="btn btn-link"
                          onClick={() => {
                            this.props.dispatch(
                              actPaymentMethod.setOpenRegistrationOutletModal(
                                true
                              )
                            );
                          }}
                        >{`${outlets.length} outlets`}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>{`KTP Number`}</label>
                      <Field
                        component={SettingField}
                        type="text"
                        placeholder="KTP"
                        name="ktp_number"
                        positiveNumberOnly
                        maxFractionDigits={0}
                        maxLength="16"
                        dis={!isKtpNumberEmpty}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>{`NPWP Number`}</label>
                      <Field
                        component={SettingField}
                        type="text"
                        placeholder="NPWP"
                        name="npwp_number"
                        maxLength="15"
                        positiveNumberOnly
                        maxFractionDigits={0}
                        dis={!isNpwpNumberEmpty}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label for="ktp_name">{`KTP Name`}</label>
                      {this.isKtpNameMandatory() ? (
                        <Field
                          id="ktp_name"
                          name="ktp_name"
                          component={SettingLetter}
                          placeholder="KTP Name"
                          type="text"
                          maxLength="255"
                          validate={this.isFieldValid}
                          dis={!isKtpNameEmpty}
                          letterOnly
                        />
                      ) : (
                        <Field
                          id="ktp_name"
                          name="ktp_name"
                          component={SettingLetter}
                          placeholder="KTP Name"
                          type="text"
                          maxLength="255"
                          dis={!isKtpNameEmpty}
                          letterOnly
                        />
                      )}
                    </div>
                  </div>
                </div>
                <h4>{`Bank Account Information`}</h4>
                <hr />
                {businessBankAccountList.length === 0 && (
                  <div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>{`Bank`}</label>
                          <Field
                            component={DropdownBank}
                            name="bank_name"
                            onChangeValue={e => {
                              this._onChangeBankName(e, generatedBankList);
                            }}
                            banks={generatedBankList}
                          />
                          <Field component="hidden" name="swift_code" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>{`Account Number`}</label>
                          <Field
                            component={SettingField}
                            type="text"
                            placeholder="Account Number"
                            name="bank_account_number"
                            positiveNumberOnly
                            maxFractionDigits={0}
                            maxLength="25"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>{`Account Holder Name`}</label>
                          <Field
                            component={SettingField}
                            type="text"
                            placeholder="Holder Name"
                            name="holder_name"
                            maxLength="255"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {businessBankAccountList.length > 0 && (
                  <div>
                    <table className={`table ${styles['table-bank-account']}`}>
                      <thead>
                        <tr>
                          <th className={`col-md-2`}>{`Bank`}</th>
                          <th className={`col-md-3`}>{`Account Number`}</th>
                          <th className={`col-md-3`}>{`Account Holder`}</th>
                          <th className={`col-md-3`}>{`Assigned Outlets`}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {businessBankAccountList.map(businessBankAccount => {
                          const id =
                            businessBankAccount.business_bank_account_id;
                          const bankName =
                            hashedBank[businessBankAccount.bank_id].bank_name;
                          const accHolderName =
                            businessBankAccount.account_holder_name;
                          const accHolderNumber =
                            businessBankAccount.account_holder_number;
                          const { outlets } = businessBankAccount;
                          const totalBankAccountActiveOutlet = this.countBankAccountActiveOutlet(
                            outlets
                          );

                          const bankAccountDetail = {
                            bankId: businessBankAccount.bank_id,
                            bankAccId: id,
                            bankName,
                            accHolderName,
                            accHolderNumber,
                            outlets,
                          };

                          return (
                            <tr key={id}>
                              <td>{bankName}</td>
                              <td>{accHolderNumber}</td>
                              <td>{accHolderName}</td>
                              {totalBankAccountActiveOutlet > 0 ? (
                                <td>
                                  {`${totalBankAccountActiveOutlet} outlets`}
                                  <button
                                    type="button"
                                    onClick={() => {
                                      this._onClickAssignBankAccount(
                                        bankAccountDetail
                                      );
                                    }}
                                    className={`btn btn-default ${
                                      styles[
                                        'edit-business-bank-account-button'
                                      ]
                                    }`}
                                  >
                                    Edit
                                  </button>
                                </td>
                              ) : (
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      this._onClickAssignBankAccount(
                                        bankAccountDetail
                                      );
                                    }}
                                    className={`btn btn-default ${
                                      styles[
                                        'edit-business-bank-account-button'
                                      ]
                                    }`}
                                  >
                                    Assign
                                  </button>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="row">
                  <div className="col-md-6 col-md-push-6">
                    <div className="form-group">
                      <button
                        type="button"
                        className="btn btn-primary btn-block"
                        onClick={() => {
                          this._onClickAddBankAccount();
                        }}
                      >
                        {`Add Bank Account`}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`row ${styles['submit-cancel']}`}>
                <div className="col-md-6">
                  <button
                    onClick={() => {
                      this.props.dispatch(
                        actPaymentMethod.onClickCancelRegistration()
                      );
                    }}
                    style={{ color: '#2e79b9' }}
                    className={`btn btn-default text-center btn-block`}
                  >
                    {`Cancel`}
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    onClick={() => {
                      this.onClickSubmitButton();
                    }}
                    className={`btn btn-primary text-center btn-block`}
                    disabled={this.isSubmitButtonDisabled()}
                  >
                    {`Submit`}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    assignedOutlets,
    bankAccountData,
    showModalAssignOutletsOnRegistration,
    paymentMethodKey,
    paymentMethodOutlets,
    accordionActiveKey,
    outlets,
    bankList,
    businessBankAccountList,
    selectedPaymentMethodList,
  } = state.setting.paymentMethod;
  return {
    paymentMethodKey,
    accordionActiveKey,
    outlets,
    bankAccountData,
    showModalAssignOutletsOnRegistration,
    assignedOutlets,
    paymentMethodOutlets,
    bankList,
    businessBankAccountList,
    isValidPaymentRegistration: isValid('paymentRegistration')(state),
    formValuePaymentRegistration: getFormValues('paymentRegistration')(state),
    initPaymentRegistration: getFormInitialValues('paymentRegistration')(state),
    userData: state.moka.user,
    selectedPaymentMethodList,
  };
}

const mapForm = {
  form: 'paymentRegistration',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

export default connect(mapStateToProps)(reduxForm(mapForm)(RegistrationForm));
